module.exports = __webpack_public_path__ + "img/97c4b838ea7a18f4869048ed013ebeae.f58297df.png";